import { config } from "JS/Config";
import { getSignedPublicUrl } from "JS/Helpers";
import { DocumentDetails } from "JS/Models";
import { BaseService } from "../BaseService";

export class DocumentsService extends BaseService {
    async getDocumentDetails(): Promise<DocumentDetails[]> {
        const docsConfig = config?.s3?.documents;

        const objectKey = `${docsConfig?.baseUrl}/${docsConfig?.description}`;
        const signedUrl = await getSignedPublicUrl(objectKey);

        const response = await fetch(signedUrl);

        if (!response.ok) {
            throw new Error(`Failed to fetch document: ${response.statusText}`);
        }

        const data = await response.json();
        return data as DocumentDetails[];
    }
}
